import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { useCatchResponse } from '../../../utils/useCatchResponse';


const Examination = () => {
    const { catchResponse } = useCatchResponse();
    const [activeTab, setActiveTab] = useState(0);
    const [securityUserID, setSecurityUserID] = useState("");
    const [selectedYear, setSelectedYear] = useState('');
    const navigate = useNavigate();
    const [pageAccess, setPageAccess] = useState({});
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [examScheduleOnGoingMarksList, setExamScheduleOnGoingMarksList] = useState([]);
    const [examScheduleCompletedMarksList, setExamScheduleCompletedMarksList] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        const accessData = CommonConfig.getUserAccess('Examination');
        setPageAccess(accessData);
        getFinancialYearData(loginData);
    }, []);

    const getFinancialYearData = async (loginData) => {
        const years = await CommonConfig.getFinancialYears(loginData?.CreatedBy);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetExamScheduleList(loginData?._id, CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy, selectedAcYear ?? currentYear?.value);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const GetExamScheduleList = async (id, schId, financialId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schId,
                FinancialYearId: financialId
            }
            Loader.show();
            await api.post(APIConstant.path.GetExamScheduleMarksList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data.filter(x => x?.IsAllow === true);
                    var completeList = res?.data.filter(x => x?.IsAllow === false);
                    setExamScheduleOnGoingMarksList(onGoingList);
                    setExamScheduleCompletedMarksList(completeList);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const checkedTemplate = (rowData) => (
        <span style={{ color: "green" }}>{rowData?.Checked}</span>
    );

    const actionTemplate = (rowData) => (
        <div className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
            {(pageAccess?.AddAccess && rowData?.IsAllow) &&
                <Button icon="pi pi-cog" tooltip="Configure" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/examination-marks', { state: { className: rowData?.ClassName, subjectName: rowData?.SubjectName, classId: rowData?.ClassId, examId: rowData?.ExamId, subjectId: rowData?.SubjectId, termId: rowData?.TermId, isAllow: rowData?.IsAllow, financialYearId: selectedYear, isGradeAllow: rowData?.IsGradeAllow, sectionName: rowData?.SectionName } })} />
            }

            {(pageAccess?.ViewAccess && !rowData?.IsAllow) &&
                <Button icon="pi pi-eye" tooltip="View" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/examination-marks', { state: { className: rowData?.ClassName, subjectName: rowData?.SubjectName, classId: rowData?.ClassId, examId: rowData?.ExamId, subjectId: rowData?.SubjectId, termId: rowData?.TermId, isAllow: rowData?.IsAllow, financialYearId: selectedYear, isGradeAllow: rowData?.IsGradeAllow, sectionName: rowData?.SectionName } })} />
            }
            {(!rowData?.IsAllow && pageAccess?.EditAccess) && <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/examination-marks', { state: { className: rowData?.ClassName, subjectName: rowData?.SubjectName, classId: rowData?.ClassId, examId: rowData?.ExamId, subjectId: rowData?.SubjectId, termId: rowData?.TermId, isAllow: true, financialYearId: selectedYear, isGradeAllow: rowData?.IsGradeAllow, sectionName: rowData?.SectionName } })} />}
        </div>

    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-book"></i>
                    <h2>Examination</h2>
                </div>
                <div className="e-tab-main p-ml-2 p-d-flex p-jc-center p-ai-center" style={{ flex: 1, height: 'auto', flexDirection: 'row', display: 'flex' }}>
                    <ul className="p-tabview-nav" style={{ margin: 0, padding: 0, border: 'none', background: 'none' }}>
                        <li className={activeTab === 0 ? "p-highlight" : ""} onClick={() => setActiveTab(0)}>
                            <a className="p-tabview-nav-link" style={{ cursor: 'pointer', backgroundColor: activeTab === 0 ? '#4e8ba5' : '', color: activeTab === 0 ? '#FFFFFF' : '' }}>
                                <span className="p-tabview-title" style={{ color: activeTab === 0 ? '#FFFFFF' : '' }}>Ongoing</span>
                            </a>
                        </li>
                        <li className={activeTab === 1 ? "p-highlight" : ""} onClick={() => setActiveTab(1)}>
                            <a className="p-tabview-nav-link" style={{ cursor: 'pointer', backgroundColor: activeTab === 1 ? '#4e8ba5' : '', color: activeTab === 1 ? '#FFFFFF' : '' }}>
                                <span className="p-tabview-title" style={{ color: activeTab === 1 ? '#FFFFFF' : '' }}>Completed</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <>
                {activeTab === 0 && (
                    <DataTable value={examScheduleOnGoingMarksList} paginator
                        rows={rows}
                        first={first}
                        filters={filters}
                        globalFilterFields={['ExamType', 'ClassName', 'SectionName', 'SubjectName', 'TermName']}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ minWidth: '3rem', maxWidth: '6rem' }} />
                        <Column field="ExamType" header="Exam Name" style={{ minWidth: '12rem', maxWidth: '18rem' }} />
                        <Column field="ClassName" header="Class" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="SectionName" header="Section" style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column field="SubjectName" header="Subject Name" style={{ minWidth: '10rem', maxWidth: '10rem' }} />
                        <Column field="TermName" header="Term Name" style={{ minWidth: '10rem', maxWidth: '10rem' }} />
                        <Column field="TotalStudents" header="Students" style={{ minWidth: '3rem', maxWidth: '6rem' }} />
                        <Column header="Checked" body={checkedTemplate} style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} headerStyle={{ width: '100%' }} />
                    </DataTable>
                )}
                {activeTab === 1 && (
                    <DataTable value={examScheduleCompletedMarksList} paginator
                        rows={rows}
                        first={first}
                        filters={filters}
                        globalFilterFields={['ExamType', 'ClassName', 'SectionName', 'SubjectName', 'TermName']}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ minWidth: '3rem', maxWidth: '3rem' }} />
                        <Column field="ExamType" header="Exam Type" style={{ minWidth: '12rem', maxWidth: '18rem' }} />
                        <Column field="ClassName" header="Class" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="SectionName" header="Section" style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column field="SubjectName" header="Subject" style={{ minWidth: '10rem', maxWidth: '10rem' }} />
                        <Column field="TermName" header="Term Name" style={{ minWidth: '10rem', maxWidth: '10rem' }} />
                        <Column field="TotalStudents" header="Students" style={{ minWidth: '3rem', maxWidth: '6rem' }} />
                        <Column header="Checked" body={checkedTemplate} style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} headerStyle={{ width: '100%' }} />
                    </DataTable>
                )}
            </>
        </div>
    );
};

export default Examination;
